'use strict';

angular.module('amexReconciliationApp')
  .service('ReceiptService', function (TransactionSearchModel, SiteConfigModel) {
    var VIEWABLE_TYPES = ['jpg', 'jpeg', 'gif', 'bmp', 'png'];

    var self = this;

    self.isReceiptViewable = function isReceiptViewable(receipt) {
      return self.isReceiptViewableByName(receipt.fileName);
    };

    self.isReceiptViewableByName = function isReceiptViewableByName(receiptName) {
      var extension = receiptName.split('.').slice(-1)[0];
      return _.includes(VIEWABLE_TYPES, extension.toLowerCase());
    };

    self.receiptUploadingIsLocked = function receiptUploadingIsLocked() {
      var currentBillingCycle = TransactionSearchModel.billingCycle();
      var siteConfiguration = SiteConfigModel.siteConfig();

      if (currentBillingCycle && siteConfiguration) {
        return todayIsPastReceiptLockDayWindow(siteConfiguration.receiptLockDays,
          currentBillingCycle.endDate);
      }

      return true;
    };

    function todayIsPastReceiptLockDayWindow(lockDays, billingDate) {
      var today = moment().startOf('day');
      var window = moment(billingDate).add(lockDays, 'days');

      var timeToLockDate = window.diff(today, true);

      return timeToLockDate < 0;
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ReceiptService.js
// module id = 644
// module chunks = 0